<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();
const { t } = useI18n();

const whatsapp = computed(() => contentAttributes.value?.whatsapp || {});

const buttonLabel = computed(() => {
  return whatsapp.value.button || t('CONVERSATION.WHATSAPP_LIST.VIEW_OPTIONS');
});

const selectedValue = computed(() => {
  const [item] = contentAttributes.value?.submittedValues ?? [];
  return item?.value || item?.title;
});

const sections = computed(() => {
  const groupedSections = whatsapp.value.sections || [];
  if (groupedSections.length) return groupedSections;

  const items = contentAttributes.value?.items || [];
  if (!items.length) return [];

  return [
    {
      title: '',
      rows: items.map(item => ({
        id: item.value,
        title: item.title,
        description: item.description,
      })),
    },
  ];
});

const isSelectedRow = row => {
  const id = row.id || row.value;
  return (
    !!selectedValue.value &&
    (selectedValue.value === id || selectedValue.value === row.title)
  );
};
</script>

<template>
  <BaseBubble class="px-0 py-0 overflow-hidden" data-bubble-name="whatsapp-list">
    <div class="px-4 py-3">
      <span v-dompurify-html="content" class="prose prose-bubble" />
    </div>
    <div
      class="px-4 py-2 border-t border-n-strong text-center text-sm font-medium"
    >
      {{ buttonLabel }}
    </div>
    <div
      v-for="(section, sectionIndex) in sections"
      :key="section.title || sectionIndex"
      class="border-t border-n-strong"
    >
      <p
        v-if="section.title"
        class="px-4 py-2 text-xs font-semibold text-n-slate-11 bg-n-alpha-2"
      >
        {{ section.title }}
      </p>
      <ul class="divide-y divide-n-strong">
        <li
          v-for="row in section.rows"
          :key="row.id || row.title"
          class="px-4 py-2"
          :class="{ 'bg-n-alpha-2': isSelectedRow(row) }"
        >
          <p class="text-sm font-medium">{{ row.title }}</p>
          <p v-if="row.description" class="mt-0.5 text-xs text-n-slate-11">
            {{ row.description }}
          </p>
        </li>
      </ul>
    </div>
    <dl v-if="selectedValue" class="px-4 py-3 border-t border-n-strong">
      <dt class="italic text-n-slate-11">{{ t('CONVERSATION.RESPONSE') }}</dt>
      <dd>{{ selectedValue }}</dd>
    </dl>
  </BaseBubble>
</template>
